module.exports = __webpack_public_path__ + "static/media/skepp.8534b51d.mp3";